<template>
  <tr>
    <td>{{ patientName }}</td>
    <td>
      {{ startDate }}<br />
      <span v-if="closeDate" :class="{ 'text-danger': isTimeToClose }">
        {{ closeDate }}
      </span>
    </td>
    <td>{{ doctorName }}</td>
    <td>
      <status-title :status="course.status" :type="'course'"></status-title><br />
      <small class="text-muted">{{ finishedTrainings }}</small>
      <small class="text-muted"> ({{ courseType }})</small>
    </td>
    <td>{{ deviceName }}</td>
    <td>
      <last-training-info :training="course.last_training"></last-training-info>
    </td>
    <td>{{ $t('general.idAbbr') }}: {{ course.id }}</td>
    <td>
      <span
        v-if="haveNewMessage"
        class="icon icon_primary icon-message"
        :title="$t('src/components/table-rows/coursetablerow.750')"
      >
        <div class="message-new"></div>
      </span>
    </td>
    <td>
      <router-link
        :to="{ name: 'course-edit', params: { id: course.id } }"
        class="btn btn-outline-primary btn-sm"
        >{{ $t('button.open') }}</router-link
      >
    </td>
  </tr>
</template>

<script>
import LastTrainingInfo from '@/components/Training/LastTrainingInfo.vue'
import StatusTitle from '@/components/StatusTitle.vue'
import { DATE_FORMAT, status } from '@/main.config'
import { nowMoment } from '@/mixins/now-moment'
import { courseDate } from '@/mixins/course-date'
import { courseTypeList } from '@/modules/course-type-list'
import { userRights } from '@/mixins/user-rights.js'

export default {
  name: 'CourseTableRow',
  components: {
    LastTrainingInfo,
    StatusTitle
  },
  mixins: [nowMoment, courseDate, userRights],
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  computed: {
    patientName() {
      return this.isNeuroAdmin
        ? String(this.course.patient_id).padStart(5, '0')
        : `${this.course.patient_surname} ${this.course.patient_name}`
    },
    doctorName() {
      return this.isNeuroAdmin
        ? String(this.course.doctor_id).padStart(5, '0')
        : `${this.course.doctor_surname} ${this.course.doctor_name}`
    },
    isTimeToClose() {
      if ([status.closed, status.closedWrong].includes(this.course.status)) {
        return false
      }
      return this.momentCloseDate.isBefore(this.nowMoment)
    },
    momentCloseDate() {
      return this.getCourseMomentEndDate(this.course)
    },
    startDate() {
      return this.getCourseMomentStartDate(this.course).format(
        DATE_FORMAT[`${this.$store.getters.LOCALE}Short`]
      )
    },
    closeDate() {
      return this.momentCloseDate
        ? this.momentCloseDate.format(DATE_FORMAT[`${this.$store.getters.LOCALE}Short`])
        : null
    },
    finishedTrainings() {
      return `${this.course.finished_training_count}/${this.course.total_training_count}`
    },
    deviceName() {
      return this.course.device?.serial_number || ''
    },
    courseType() {
      if (!this.course.course_type) {
        return ' - '
      }
      return courseTypeList[this.course.course_type].shortTitle
    },
    haveNewMessage() {
      return !!this.course.unread_messages
    }
  }
}
</script>
